import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private tableReloadSrc = new BehaviorSubject({ userid: '', tableReload: false, from: null, task: null, userData: {} });
  private tableReloadData = this.tableReloadSrc.asObservable();

  private sidebarSrc = new BehaviorSubject(true);
  private sidebarData = this.sidebarSrc.asObservable();

  constructor() { }

  // triggers the table src to send true value
  public triggerTableReload(userid, from, task, data) {
    this.tableReloadSrc.next({ userid: userid, tableReload: true, from: from, task: task, userData: data });
  }

  // get table triggers
  public getTableTriggers(): Observable<any> {
    return this.tableReloadData;
  }

  // triggers sidebar to toggle
  public triggerSidebar() {
    this.sidebarSrc.next(true);
  }

  // get sidebar toggle triggers
  public getSidebarToggle() {
    return this.sidebarData;
  }


}
